<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-14 10:55:43
 * @LastEditTime: 2026-04-23 09:44:05
 * @LastEditors: ranli
-->
<template>
  <van-notify v-model:show="visible" :type="type" :duration="duration" :color="color"
    :background="background || typeColors[type]" class="custom-toast-notify" @close="handleClose">
    <div class="toast-inner">
      <span class="toast-message">{{ message }}</span>
      <van-icon name="cross" class="toast-close" @click="handleClose" />
    </div>
  </van-notify>
</template>

<script setup>
/**
 * Toast 顶部通知组件
 * @description 从顶部滑入，内容左对齐，右侧关闭按钮
 * @property {boolean} modelValue - 控制显示/隐藏
 * @property {string} message - 通知内容
 * @property {string} type - 通知类型 info/danger/primary/warning
 * @property {number} duration - 显示时长(ms)
 * @property {string} color - 自定义文字颜色
 * @property {string} background - 自定义背景色
 */
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'info',
  },
  duration: {
    type: Number,
    default: 2000,
  },
  color: {
    type: String,
    default: '',
  },
  background: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue', 'close'])

const visible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
  },
})

const handleClose = () => {
  visible.value = false
  emit('close')
}

const typeColors = {
  info: '#1989fa',
  danger: '#d82d2c',
  primary: '#109e38',
  warning: '#109e38',
  success: '#2283F6',
}
</script>

<style lang="less">
.custom-toast-notify {
  top: 10px !important;
  border-radius: 4px !important;
  width: 95% !important;
  margin-left: 2.5% !important;
}

.toast-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  word-break: break-word;
}

.toast-message {
  flex: 1;
  text-align: left;
  font-size: 14px;
  line-height: 15px;
  padding: 5px 0;
}

.toast-close {
  flex-shrink: 0;
  margin-left: 12px;
  cursor: pointer;
  font-size: 16px;
}
</style>
